import './common'
import '../scss/style.scss';

import '~components/tooltip/tooltip'
import '~components/forms/select/select'
import '~components/map/map'
import {Tooltip} from "../components/tooltip/tooltip";
import {Tooltipster} from "../components/tooltipster/tooltipster";
import {Tabs} from "../components/tabs/tabs";
import {Map} from "../components/map/map";
import {Form} from "../components/forms/form/form";
import {Popup} from "../components/popup/popup";


$(window).on('load', function () {
  $(document).on('click', '[data-bonus-card-apply]', function () {
      let parentBlock = $(this).parents('.js-loyalty-form');
      let card = parseInt(parentBlock.find('[data-bonus-card]').val());
      if(!card){
        return;
      }
      if ($('[data-preloader]').length > 0) {
        $('[data-preloader]').show();
      }
      $.ajax({
        type: "POST",
        url: parentBlock.data('handler') + '/ajax.php',
        data: {
          'sessid': parentBlock.find('input[name="sessid"]').val(),
          'loyaltyCardNumber': parentBlock.find('[data-bonus-card]').val(),
          'action': 'info',
          'white': 'Y'
        },
        success: function (msg) {
          parentBlock.html(msg);

          if ($('[data-preloader]').length > 0) {
            $('[data-preloader]').hide();
          }
          submitForm();
        }
      });
    });

    $(document).on('change', '[data-bonus-card-info-checkbox]', function () {
      if ($('[data-bonus-card-info-checkbox]').is(':checked')) {
        $.magnificPopup.open({
          items: {
            src: '#' + $(this).attr('data-src'),
          },
          type:'inline',
          midClick: true,
          closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
          removalDelay: 500, //delay removal by X to allow out-animation
          callbacks: {
            beforeOpen: function() {
              this.st.mainClass = 'mfp-zoom-in mfp-modal';
            }
          }
        });
      } else {
        let parentBlock = $(this).parents('.js-loyalty-form');
        $.ajax({
          type     : "POST",
          url      : parentBlock.data('handler') + '/ajax.php',
          dataType : 'json',
          data     : {
            'sessid' : parentBlock.find('input[name="sessid"]').val(),
            'action' : 'applyBonuses',
            'loyaltyCardNumber' : $('.js-loyalty-card-input').val(),
            'applyBonuses'   : $(this).prop('checked') ? 'Y' : 'N',
            'white'  : 'Y'
          },
          success  : function(response) {
            if (response.success) {
              submitForm();
            }
          }
        });
      }
    });

    $(document).on('click', '[data-popup-bonus-card-check-button]', function () {
      const type = $(this).attr('data-popup-bonus-card-check-button');
      let parentBlock = $('#popup-bonus-card-check');
      let card = $(this).attr('data-value');
      if(!card){
        return;
      }
      if ($('[data-preloader]').length > 0) {
        $('[data-preloader]').show();
      }
      parentBlock.find('#js-code-error').html('');
      $.ajax({
        type: "POST",
        url: parentBlock.data('handler') + '/ajax.php',
        dataType : 'json',
        data: {
          'sessid': parentBlock.find('input[name="sessid"]').val(),
          'action': 'sendCode',
          'type' : type,
          'white': 'Y'
        },
        success: function (data) {
          if (data.success) {
            parentBlock.find('.js-loyalty-code-info').hide()
            parentBlock.find('.js-loyalty-code-confirm').show()
            if(type == 'email'){
              $('[data-send-email-message]').removeClass('d-none')
            }
            if(type == 'phone'){
              $('[data-send-phone-message]').removeClass('d-none')
            }
          } else {
            parentBlock.find('#js-code-error').html(window.pmMessages.codeSendError)
          }

          if ($('[data-preloader]').length > 0) {
            $('[data-preloader]').hide();
          }
        }
      });

    });

    $(document).on('click', '[data-popup-bonus-card-confirm-code]', function () {
      let parentBlock = $('#popup-bonus-card-check');
      let code = parentBlock.find('[data-loyalty-confirm-code]').val();

      if ($('[data-preloader]').length > 0) {
        $('[data-preloader]').hide();
      }
      if (code.length > 4) {
        $.ajax({
          type     : "POST",
          url      : parentBlock.data('handler') + '/ajax.php',
          dataType : 'json',
          data     : {
            'sessid' : parentBlock.find('input[name="sessid"]').val(),
            'action' : 'confirmCode',
            'code'   : code,
            'white'  : 'Y'
          },
          success  : function(response) {
            if (response.success) {
              $.magnificPopup.close();
              $.ajax({
                type     : "POST",
                url      : parentBlock.data('handler') + '/ajax.php',
                dataType : 'json',
                data     : {
                  'sessid' : parentBlock.find('input[name="sessid"]').val(),
                  'action' : 'applyBonuses',
                  'loyaltyCardNumber' : $('.js-loyalty-card-input').val(),
                  'applyBonuses'   : $('[data-bonus-card-info-checkbox]').prop('checked') ? 'Y' : 'N',
                  'white'  : 'Y'
                },
                success  : function(response) {
                  if (response.success) {
                    submitForm();
                  }
                }
              })
            } else {
              parentBlock.find('#js-code-error').html(window.pmMessages.codeIncorrect)
            }

            if ($('[data-preloader]').length > 0) {
              $('[data-preloader]').hide();
            }
          }
        })
      }
      return false;
    });

    $(document).on('click', '[data-bonus-card-delete]', function () {
      if ($('[data-preloader]').length > 0) {
        $('[data-preloader]').show();
      }
      let parentBlock = $(this).parents('.js-loyalty-form');
      $.ajax({
        type: "POST",
        url: parentBlock.data('handler') + '/ajax.php',
        data: {
          'sessid': parentBlock.find('input[name="sessid"]').val(),
          'action': 'delete',
          'white': 'Y'
        },
        success: function (msg) {
          parentBlock.html(msg);
          if ($('[data-preloader]').length > 0) {
            $('[data-preloader]').hide();
          }
        }
      });
    });

    $(document).on('click', '[data-cart-set-coupon]', function(e) {
      e.preventDefault();
      var coupon = $('#coupon').val();

      $.post(window.langUrl + '/local/ajax/set_coupon.php', {
        sessid : $('#sessid').val(),
        coupon : coupon
      }).done(function(data) {
        submitForm();
      });
    });

    $(document).on('click', '[data-cart-remove-coupon]', function(e) {
      $.post(window.langUrl + '/local/ajax/remove_coupon.php', {
        sessid : $('#sessid').val(),
        coupon : $(this).attr('data-coupon')
      }).done(function(data) {
        submitForm();
      });
    });

    //инициализация карты для СДЭК
    $(document).on('click', '#map-point-link', function(e) {
      let target = $('#map-point');
      target.html('');
      let map = new Map(target);
      map.initialize();
    });

    if (
      typeof checkContactsFill == 'function'
      && typeof dataLayerCheckoutStep1 == 'function'
    ) {
      if (checkContactsFill()) {
        if (dataLayerCheckoutStep1()) {
          window.dl_checkout_step1 = true;
        }
      }

    }
    $(document).on('keyup', '[data-contact-info]', function(e) {
      if (
        typeof window.dl_checkout_step1 == 'undefined'
        || (
          typeof window.dl_checkout_step1 != 'undefined'
          && window.dl_checkout_step1 == false
        )
      ) {
        if (typeof dataLayerCheckoutStep1 == 'function') {
          if (dataLayerCheckoutStep1()) {
            window.dl_checkout_step1 = true;
          }
        }
      }
    });

});

/**
 * Функция при загрузке страницы производит проверку заполненности полей контактов
 */
function checkContactsFill() {
  let isContactsFill = false;
  let checkContacts = [];
  let contacts = $('[data-contact-info]');
  if (contacts.length > 0) {
    contacts.each(function() {
      let item = $(this);
      if (item.val().length > 0) {
        checkContacts.push(true);
      }
    });

    if (contacts.length == checkContacts.length) {
      isContactsFill = true;
    }

    return isContactsFill;
  }
}

/**
 * Функция добавляет данные в dataLayer о событии начала заполнении контактных данных (GTM).
 */
function dataLayerCheckoutStep1()
{
  if (typeof window.gtm_cart_items !== 'undefined') {
    let products = [];
    window.gtm_cart_items.forEach(function(item) {
      products.push({
        'name'     : item.name,
        'id'       : item.product_id,
        'price'    : item.price,
        'brand'    : item.brand,
        'category' : item.category,
        'variant'  : item.variant,
        'quantity' : item.quantity,
      });
    });

    dataLayer.push({
      'ecommerce'                    : {
        'checkout' : {
          'actionField'  : {
            'option' : 'contacts',
            'step'   : 1
          },
          'products'     : products,
          'currencyCode' : 'KZT'
        }
      },
      'event'                        : 'gtm-ee-event',
      'gtm-ee-event-action'          : 'Checkout Step 1',
      'gtm-ee-event-category'        : 'Enhanced Ecommerce',
      'gtm-ee-event-non-interaction' : 'False'
    });

    return true;
  } else {
    return false;
  }
}

function getDeliveryType()
{
  var _deliveryId = $('input[type="radio"][name="DELIVERY_ID"]:checked').val();
  var _type = '';
  for (var _i in window.deliveryId) {
    if (window.deliveryId[_i] == _deliveryId) _type = _i;
  }
  return _type;
}

window.submitForm = function(callback) {
  let orderForm = $('#ORDER_FORM');

  let _params = orderForm.serializeArray();

  let _ajax = orderForm.data('ajax');
  if (_ajax) _ajax.abort();

  if ($('[data-preloader]').length > 0) {
    $('[data-preloader]').show();
  }

  _ajax = $.post(orderForm.attr('action') + 'index.ajax.php', _params, function(data) {

    try {
      // if json came, it obviously a successfull order submit
      var json = JSON.parse(data);

      if (json.error) {

        $.magnificPopup.open({
          items: {
            src: '#js-popup-error'
          },
          type:'inline',
          midClick: true,
          closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
          removalDelay: 500, //delay removal by X to allow out-animation
          callbacks: {
            beforeOpen: function() {
              this.st.mainClass = 'mfp-zoom-in';
              if ($('[data-preloader]').length > 0) {
                $('[data-preloader]').hide();
              }
            },
            close: function() {
              window.location.href = '/personal/cart/';
            }
          }
        });

      } else if (json.success === 'Y' && json.redirect) {

        $.magnificPopup.open({
          items: {
            src: '#popup-order-success'
          },
          type:'inline',
          midClick: true,
          closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
          removalDelay: 500, //delay removal by X to allow out-animation
          callbacks: {
            beforeOpen: function() {
              this.st.mainClass = 'mfp-zoom-in';
              if ($('[data-preloader]').length > 0) {
                $('[data-preloader]').hide();
              }
            },
            open: function() {
              let match = json.redirect.match('(?:ORDER_ID=)(.*)')
              if (typeof match == 'object') {
                $('#popup-order-success').find('[data-popup-order-success-order-num]').html(match[1])
                $('#popup-order-success').find('[data-order-info-link]').attr('href', json.redirect.replace('index.ajax.php', ''))

                let orderFormCur = orderForm[0];
                let orderId = match[1];
                let email = '';
                try {
                  email = orderFormCur.elements["ORDER_PROP_" + window.orderProps.EMAIL].value;
                } catch (e) {}

                if (
                  orderFormCur.elements.agree_to_mailing.checked
                  && email.length > 0
                ) {
                  (window["rrApiOnReady"] = window["rrApiOnReady"] || [])
                    .push(function() {
                      rrApi.setEmail(email, {stockId: window.stock_id});
                    });
                }

                // gtm
                if (
                  typeof window.gtm_order !== 'undefined'
                  && typeof window.gtm_cart_items !== 'undefined'
                ) {

                  let products = [];
                  window.gtm_cart_items.forEach(function(item_gtm) {
                    products.push({
                      'name'     : item_gtm.name,
                      'id'       : item_gtm.product_id,
                      'price'    : item_gtm.price,
                      'brand'    : item_gtm.brand,
                      'category' : item_gtm.category,
                      'variant'  : item_gtm.variant,
                      'position' : item_gtm.position
                    })
                  });
                  let deliveryId = orderFormCur.elements.DELIVERY_ID;
                  let option = null;
                  switch (deliveryId.value) {
                    case '33':
                      option = 'courier';
                      break;
                    case '34':
                      option = 'pickup';
                      break;
                  }

                  dataLayer.push({
                    'ecommerce'                    : {
                      'checkout' : {
                        'actionField'  : {
                          'option' : option,
                          'step'   : 2
                        },
                        'products'     : products,
                        'currencyCode' : 'KZT'
                      }
                    },
                    'event'                        : 'gtm-ee-event',
                    'gtm-ee-event-action'          : 'Checkout Step 2',
                    'gtm-ee-event-category'        : 'Enhanced Ecommerce',
                    'gtm-ee-event-non-interaction' : 'False'
                  });
                  dataLayer.push({
                    'ecommerce' : {
                      'purchase' : {
                        'actionField' : {
                          'id'          : orderId,
                          'affiliation' : 'NewBalance',
                          'revenue'     : window.gtm_order.order_total_price,
                          'tax'         : window.gtm_order.tax_price,
                          'shipping'    : window.gtm_order.delivery_price,
                        },
                        'products'    : products
                      }
                    },
                    'event': 'gtm-ee-event',
                    'gtm-ee-event-action': 'Purchase',
                    'gtm-ee-event-category': 'Enhanced Ecommerce',
                    'gtm-ee-event-non-interaction': 'False'
                  });

                } // \gtm

              }
              setTimeout(() => {
                window.location = json.redirect;
              }, 5000);
            },
            close: function() {
              window.location = json.redirect;
            }
          }
        });
        // window.top.location.href = json.redirect;
      }else if(json.success === 'N' && json.redirect){
        window.location = json.redirect.replace('index.ajax.php', '');
      }
    } catch (e) {
      // json parse failed, so it is a simple chunk of html
      if ($('[data-preloader]').length > 0) {
        $('[data-preloader]').hide();
      }
      // BXFormPosting = false;
      $('#order_form_content').html(data);

      //Если тип доставки Забрать в пункте выдачи и уже был выбран ПВЗ, при переключении нужно показать что выбрано
      let storeID = $('#ORDER_PROP_' + window.orderProps['STORE_ID']).val();
      let address = $('#ORDER_PROP_' + window.orderProps['F_ADDRESS']).val();
      if(storeID != '' && address != ''){
        $('[data-order-adress-set]').click()
      }

      if ($('[data-cart]').length > 0) {

        let carts = [];

        $('[data-cart]').each(function(i) {
          carts[i] = new Cart($(this));
          carts[i].initializeCart();
        });

        let tooltip = [];

        if ($('[data-tooltip]').length > 0) {
          $('[data-tooltip]').each(function(i) {
            tooltip[i] = new Tooltip($(this));
            tooltip[i].initialize();
          });
        }

        new Tooltipster();

        let tabs = [];

        if ($('[data-tabs-head]').length > 0) {
          $('[data-tabs-head]').each(function(i) {
            tabs[i] = new Tabs($(this));
            tabs[i].initialize();
          });
        }

        if ($('[data-tabs-header]').length > 0) {
          $('[data-tabs-header]').each(function(i) {
            tabs[i] = new Tabs($(this));
            tabs[i].initializeAbout();
          });
        }

        let map = [];

        if ($('[data-map]').length > 0) {
          $('[data-map]').each(function(i) {
            map[i] = new Map($(this));
            map[i].initialize();
          });
        }

        let popups = [];

        if ($('[data-popup-right]').length > 0) {
          $('[data-popup-right]').each(function(i) {
            popups[i] = new Popup($(this));
            popups[i].initializeRightPopup();
          });
        }

        if ($('[data-popup-schedule]').length > 0) {
          $('[data-popup-schedule]').each(function(i) {
            popups[100 + i] = new Popup($(this));
            popups[100 + i].initialize();
          });
        } else {
          $('[data-delivery-day-inputs]').html('');
          $('[data-delivery-time-inputs]').html('');
        }

        // window._aeroflot.init();
      }

      let form = new Form();

      window.Form = Form;

      // initActions();
      // initAccessories();

      if (typeof callback == 'function') {
        callback();
      }
    }

    if (window.gifts && window.hasManzanaGiftInBasket !== true) {
      showGifts(window.gifts);
    }

    if(window.paymentId && window.paymentId.bnpl) {
      window.renderBnpl(window.paymentId);
    }

  });

  orderForm.data('ajax', _ajax);
}


window.renderBnpl = function(paymentId) {
  $('[data-radio-pay]').each(function() {
    if (($(this).val() == paymentId.bnpl) && $(this).prop('checked')) {
      let popups = [];
      const totalAmountSelector = '[data-total-price]';
      const totalAmountElem = document.querySelector(totalAmountSelector);
      const totalAmount = Math.ceil(parseFloat(totalAmountElem.textContent.replace(/\s+/g, '')));
      const container = $(this).closest('label')[0];
      // if (totalAmount < $minAmount || totalAmount > $maxAmount) {
      //     disablePaymentMethod(container, input, totalAmount);
      //     return;
      // }

      let elem = document.getElementById('factoring004-schedule');
      let finalContainer = document.querySelector('.factoring004-schedule-wrapp');
      if (!finalContainer && !elem) {
        finalContainer = document.createElement('div');

        const schedule = new Factoring004.PaymentSchedule({
          elemId: 'factoring004-schedule',
          totalAmount,
        });

        elem = document.createElement('div');
        elem.id = 'factoring004-schedule';

        schedule.renderTo(elem);

        const scheduleHtml = elem.querySelector('.stepperWrapper__nlH4v').outerHTML;

        finalContainer.classList.add('factoring004-schedule-wrapp');
        finalContainer.innerHTML = `
          <p class="factoring004-top-text">${window.pmMessages.bnplCartTopText}</p>
          ${scheduleHtml}
          <p class="factoring004-bottom-text">${window.pmMessages.bnplCartBottomText}</p>
        `;

        container.insertAdjacentElement('afterend', finalContainer);

        if ($('[data-popup-right]').length > 0) {
          $('[data-popup-right]').each(function(i) {
            popups[i] = new Popup($(this));
            popups[i].initializeRightPopup();
          });
        }
      }
    }
  });
}

function showGifts(_gifts) {
  var _popup = $("#js-popup-gifts");
  var _giftList = _popup.find(".gift-list");
  _giftList.html("");

  _popup.find(".js-popup-close").click();

  if (!_gifts) return false;

  var _hasGift = false;
  var counter = 0;
  var giftsCount = _gifts.length;
  var pageCount = 12;
  var htmlContent = "";
  for (var _i in _gifts) {
    var _gift = _gifts[_i];
    _hasGift = true;
    if (counter % pageCount === 0) {
      //htmlContent += '<div>';
    }

    var giftName = _gift.NAME;
    if (_gift.ID == 254626) {
      giftName = window.pmMessages.giftBeltBag;
    }

    // var itemStyle = "display: table-cell; vertical-align: middle;";
    // if (_gift.ID == 254626 && window.innerWidth <= 390) {
    // 	itemStyle += "height: 171px;";
    // } else {
    // 	itemStyle += "height: 150px;";
    // }

    htmlContent +=
      '\
<div class="gift-one" data-id="' +
      _gift.ID +
      '" data-quantity=' +
      _gift.QUANTITY +
      " data-rule=" +
      _gift.RULE_ID +
      '>\
<div style="" class="gift-image">\
  <img src="' +
      _gift.PHOTO +
      '" alt="' +
      _gift.NAME +
      '">\
</div>\
<div class="gift-data">\
  <div class="gift-name">' +
      giftName +
      '</div>\
  <div class="gift-article">' +
      _gift.ARTICLE +
      '</div>\
  <div class="gift-size">' + window.pmMessages.giftSize + ': ' +
      _gift.SIZE +
      '</div>\
  <div class="gift-size">' + window.pmMessages.giftColor + ': ' +
      _gift.COLOR +
      '</div>\
  <div class="gift-price-discounted">1&nbsp;₸</div>\
  \<div class="gift-price">' +
      _gift.PRICES_FORMAT.SALE +
      '</div>\
  <a class="btn btn--yellow" href="#">' + window.pmMessages.choose + '</a>\
</div>\
</div>\
';

    if (counter % pageCount === pageCount - 1 || counter === giftsCount - 1) {
      //htmlContent += '</div>';
    }
    counter++;
  }
  _giftList.html(htmlContent);

  setTimeout(() => {
    $.magnificPopup.open({
      items: {
        src: '#js-popup-gifts'
      },
      type: 'inline',
      closeOnBgClick: true,
      midClick: true,
      closeMarkup: '<button title="%title%" type="button" class="mfp-close popup__close close"></button>',
      removalDelay: 500, //delay removal by X to allow out-animation
      callbacks: {
        beforeOpen: function() {
          this.st.mainClass = 'mfp-zoom-in mfp-modal';
        },
        open: function() {
          $('body').css('overflow', 'hidden');
        },
        close: function() {
          $('body').css('overflow', '');
        }
      }
    });
  }, 300);

  _giftList.find("a").on("click", function () {
    _popup.find(".popup__close").click();

    $.post(
      "/local/ajax/addtobasket.php",
      {
        gift: "Y",
        id: $(this).closest(".gift-one").data("id"),
        quantity: $(this).closest(".gift-one").data("quantity"),
        rule: $(this).closest(".gift-one").data("rule"),
        sessid: BX.bitrix_sessid()
      },
      function (response) {
        submitForm();
      }
    ).fail(function (response) {
      //console.log(response);
      BX.closeWait();
    });

    return false;
  });
}

$(function () {
  if (window.gifts && window.hasManzanaGiftInBasket !== true) {
    showGifts(window.gifts);
  }
})
